import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-add-interest-about-africa-modal',
  templateUrl: './add-interest-about-africa-modal.component.html',
  styleUrls: ['./add-interest-about-africa-modal.component.scss']
})
export class AddInterestAboutAfricaModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() set interest(value: string) {
    this.form.controls['interestedAbout'].setValue(value);
  }

  @Input() user: User;
  form: UntypedFormGroup = this.fb.group({
    interestedAbout: ['', Validators.required]
  });

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
  }

  onClose() {
    this.closed.emit();
  }

}
